export const getStyles = () => {
    const styles = {
        permissionsText: {
            maxWidth: 700,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
        },
        svgIcon: {
            fontSize: 26
        },
        title: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            lineHeight: 1.2,
        },
        cell: {
            py: 1
        }
    };
    return styles;
};